<script>
  import axios from 'axios'
  import { push } from 'svelte-spa-router'
  import Wrapper from '../Wrapper.svelte'
  import BoxCard from '../BoxCard.svelte'
  import { getURL } from '../../utils'
  import { bg_oper_support_jpg } from '../../image-base64'
  import LazyImage from '../LazyImage.svelte'
  import SearchInput from '../SearchInput.svelte'
  import { userStore, is } from '../../store'
  import Tracker from '../../tracking'

  let searchText = ''
  let searchResult = []

  let _applications = [
    {
      visible: true,
      roles: ['internal'],
      active: true,
      name: 'Complaints',
      type: 'external',
      // rootURL: '',
      rootURL: 'https://complaints.support.flexlink.io/customer/login',
      icon: 'icon_complaints.png'
    },
    {
      visible: false,
      roles: ['internal'],
      active: true,
      name: 'Customer Service',
      type: 'external',
      rootURL: '',
      icon: 'icon_068_customer_service.png'
    },
    {
      visible: true,
      roles: ['eopl'],
      active: true,
      name: 'EOPL Service Europe',
      type: 'external',
      rootURL: 'https://eopl.service.flexlink.io/customer/login',
      icon: 'icon_097_maintenance_service.png'
    },
    {
      visible: true,
      roles: ['admv'],
      active: true,
      name: 'ADMV Service',
      type: 'external',
      rootURL: 'https://admv.service.flexlink.io/support/home',
      icon: 'icon_121_mechanical_tools_01.png'
    },
    {
      visible: false,
      roles: ['internal'],
      active: true,
      name: 'Logistics Information',
      type: 'external',
      rootURL: '',
      icon: 'icon_logistics.png'
    }
  ]

  $: applications = _applications.filter(a => a.roles == null || $userStore.roles.some(r => a.roles.includes(r)))

  $: {
    console.log('[DEBUG]', applications)
    console.log($userStore.roles)
  }

  function navigate (event) {
    const {type, ref} = event.detail
    if (type === 'component') {
      push(ref)
      return
    }
    if (type === 'external') {
      window.open(ref, '_blank')
      //const url = getURL(`/private/application/go?redirect=${encodeURIComponent(ref)}`)
      //console.log('[DEBUG] url', url)
      //axios.post(url)
      //  .then(res => {
      //    if (res.data != null) {
      //      console.log('[DEBUG] response:', res.data)
      //      window.location.href = res.data
      //    }
      //  })
    }
  }

</script>

<div class="relative w-full flex items-stretch" style="min-height: 520px;">
  <LazyImage full={"static/img/bg_oper_support.png"} small={bg_oper_support_jpg} height={'520px'}
             grayscale="0%" brightness="1" />

  <div class="flex-grow flex flex-wrap items-stretch">

    <div class={'flex flex-wrap items-center mx-auto w-full lg:w-auto cards' +
      (applications.filter(a => a.visible).length < 2 ? ' justify-center' : '')}
         style="max-width: 640px;">
      {#each applications as app}
        {#if app.visible}
          <BoxCard active={app.active} title={app.name} height={260} width={320} ref={app.rootURL}
                   type={app.type} pic={app.icon}
                   on:navigate={navigate} />
        {/if}
      {/each}

    </div>

    <div class="w-full text-left px-20 my-auto flex-grow  py-16
                lg:w-1/2">

      <div class="text-white text-3xl font-light text-right pr-12">
        Operations Support
      </div>

    </div>


  </div>
</div>

<style>
    /*.icon-arrow-link::before {*/
    /*    content: "\E003";*/
    /*}*/

    .cards {
        /*width: auto;*/
    }
    @media (min-width: 1280px) {
        .cards {
            background-color: white;
            width: 640px;
        }
    }
</style>
